import React, { useEffect, ReactNode, useState } from "react";

interface TooltipProps {
  content: string | ReactNode; 
  position?: "top" | "bottom" | "left" | "right"; 
  className?: string; 
  children: ReactNode; 
  delay?: number;
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  position = "top",
  className = "",
  children,
  delay=1000
}) => {
    const [visible, setVisible] = useState(false);

    const showTooltip = () => {
        setVisible(true);
    };

    const hideTooltip = () => {
        setVisible(false);
    };

  useEffect(() => {
    if (visible) {
        const timer = setTimeout(() => {
            setVisible(false);
        }, delay);

        // Clear timer if the component unmounts or the visibility changes
        return () => clearTimeout(timer);
    }
}, [visible, delay]);


  return (
    <div className="relative inline-block">
      {/* Children element */}
      <div
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
        className="inline-block"
        tabIndex={0} // Makes it keyboard accessible
      >
        {children}
      </div>

      {/* Tooltip */}
      {visible && (
        <div
        style={{ backgroundColor: "#75484C" }}
          className={`absolute z-50 p-2 text-sm text-white rounded shadow-md whitespace-nowrap ${className} ${getTooltipPosition(
            position
          )}`}
        >
          {content}
        </div>
      )}
    </div>
  );
};

// Helper function to determine tooltip position
const getTooltipPosition = (position: string) => {
  switch (position) {
    case "top":
      return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
    case "bottom":
      return "top-full left-1/2 transform -translate-x-1/2 mt-2";
    case "left":
      return "right-full top-1/2 transform -translate-y-1/2 mr-2";
    case "right":
      return "left-full top-1/2 transform -translate-y-1/2 ml-2";
    default:
      return "";
  }
};

export default Tooltip;